import fetch from 'isomorphic-fetch';
import {message} from 'antd';
import {store} from '../index';

const URL = "https://api.dinhviso.com.vn/";

message.config({
    top: 200,
    duration: 2,
    zIndex: 1800
});

const saveSuccess = () => {
    message.success('Lưu thành công');
};

const saveError = () => {
    message.error('Có lỗi xảy ra vui lòng thủ lại');
};

export async function getIssues(query, token) {
    let bToken = `Bearer ${token}`;
    try {
        let response = await fetch(URL + query, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': bToken,
            }
        });

        let responseJson = await response.json();

        return responseJson;
    } catch (error) {
        console.error(error);
    }
}

export function getAllIssues(query, token, option, date, notiLimit) {
    let bToken = `Bearer ${token}`;
    let limit = notiLimit > 0 ? notiLimit : 5;

    return fetch(`${URL}teamweek/issues/` + query + `/${option}/${date}/${limit}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': bToken,
        }
    }).then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            return {
                status: response.status,
                message: response.statusText
            };
        }

    });
}

export function getIssue(issueID, projectID, token) {
    let bToken = `Bearer ${token}`;

    return fetch(`${URL}teamweek/issue/${projectID}/${issueID}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': bToken,
        }
    }).then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            return {
                status: response.status,
                message: response.statusText
            };
        }

    });
}

export function getissueHistory(issueID) {
    const state = store.getState();
    const token = state.token;

    if (!token && token.length === 0) {
        return;
    }

    let bToken = `Bearer ${state.token}`;

    return fetch(`${URL}teamweek/history/${state.curProjectID}/${issueID}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': bToken,
        }
    }).then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            return {
                status: response.status,
                message: response.statusText
            };
        }
    });
}

export function setStateNoti(notiID, token) {
    let state = store.getState();
    let bToken = `Bearer ${token}`;

    return fetch(`${URL}teamweek/notification/${state.curProjectID}/${notiID}`, {
        method: 'PUT',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': bToken,
        },
    }).then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            return {
                status: response.status,
                message: response.statusText
            };
        }
    });
}

export function saveIssue(issue, token) {
    let state = store.getState();
    let bToken = `Bearer ${token}`;

    return fetch(`${URL}teamweek/issues/${state.curProjectID}`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': bToken,
        },
        body: JSON.stringify(issue)
    }).then(response => {
        if (response.status === 200) {
            saveSuccess();
            return response.json();
        } else {
            saveError();
            return {
                status: response.status,
                message: response.statusText
            };
        }

    });
}

export function deleteIssue(issue, token) {
    let state = store.getState();
    let bToken = `Bearer ${token}`;

    return fetch(`${URL}teamweek/issues/${state.curProjectID}/${issue.id}`, {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': bToken,
        },
        body: JSON.stringify(issue)
    }).then(response => {
        if (response.status === 200) {
            saveSuccess();
            return response.json();
        } else {
            saveError();
            return {
                status: response.status,
                message: response.statusText
            };
        }

    });
}

export function geoCoder(locations) {
    console.log('locations : ', JSON.stringify(locations));
    return fetch(`https://geo.dinhviso.com.vn/v1.1/geocode`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(locations)
    }).then(response => {
        return response.json();
    });
}

export function postComment(comment, token) {
    let state = store.getState();
    let bToken = `Bearer ${token}`;

    return fetch(`${URL}teamweek/comment/${state.curProjectID}`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': bToken,
        },
        body: JSON.stringify(comment)
    }).then(response => {
        if (response.status === 200) {
            saveSuccess();
            return response.json();
        } else {
            saveError();
            return {
                status: response.status,
                message: response.statusText
            };
        }

    });
}



// WEBPACK FOOTER //
// ./src/services/events.js